// src/features/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    otpSent: false,
  },
  reducers: {
    setLoading: (state) => {
      //loginStart
      state.loading = true;
      state.error = null;
    },
    setUser: (state, action) => {
      //loginSuccess
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.loading = false;
    },
    setError: (state, action) => {
      // loginFailure
      state.loading = false;
      state.error = action.payload;
    },
   
  
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.otpVerified = false;
      state.otpSent = false;
    },
  },
});

export const { setUser, setLoading, setError, logout } =
  authSlice.actions;
export default authSlice.reducer;
